import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x9gc7rccbx: FaireBrandEntity = {
  token: "b_x9gc7rccbx",
  type: "brand",
  name: "Mars & Me",
  avatarUrl:
    "https://cdn.faire.com/fastly/7bb161034c7a138f9bc344cd34ea7be6826728804ba0b0288223c3c7c40424e4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/39541fabaf0e8c5142106ff2a7ac8927f88dc043c053ea78eae9c29c6ff83d88.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7bb161034c7a138f9bc344cd34ea7be6826728804ba0b0288223c3c7c40424e4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/39541fabaf0e8c5142106ff2a7ac8927f88dc043c053ea78eae9c29c6ff83d88.jpeg",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Mars & Me is a woman owned, family operated business from Louisville, KY. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.178Z",
    importedBy: "entity-db-cli",
  },
};
